import React from 'react'
import { useLoaderData } from 'react-router-dom'

import PortalPage from '../pages/PortalPage'
import BreakingImageHero from '../shared/heroes/BreakingImageHero'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PortalQuizWhatDoYouKnowAboutSleepQuizIntroModule = () => {
  const data = useLoaderData()
  const {
    page: { content },
  } = data

  return (
    <PortalPage data={data}>
      <BreakingImageHero
        title={content.hero.title}
        body={content.hero.body}
        image={content.hero.image.url}
        imageLarge={content.hero.image.urlLarge}
        imageAlt={content.hero.image.alt}
        linkUrl={content.hero.link.url}
        linkLabel={content.hero.link.label}
      />
    </PortalPage>
  )
}

export default PortalQuizWhatDoYouKnowAboutSleepQuizIntroModule
